import records from './records.en.json';
import pipelines from 'sellrm/pipelines/frontend/i18n/en.json';
import crm from 'sellrm/crm/frontend/i18n/en.json';
import emailing from 'sellrm/emailing/frontend/i18n/en.json';
import automations from 'sellrm/automations/frontend/i18n/en.json';
import notes from 'sellrm/notes/frontend/i18n/en.json';
import tasks from 'sellrm/tasks/frontend/i18n/en.json';
import liveChat from 'sellrm/live_chat/frontend/i18n/en.json';
import calendar from 'sellrm/calendar/frontend/i18n/en.json';
import scoring from 'sellrm/scoring/frontend/i18n/en.json';
import openers from 'sellrm/openers/frontend/i18n/en.json';
import whatsappUnofficial from 'sellrm/whatsapp_unofficial/frontend/i18n/en.json';
import branding from 'sellrm/branding/frontend/i18n/en.json';
import agentAccess from 'sellrm/agent_access/frontend/i18n/en.json';

export default {
  ...records,
  ...pipelines,
  ...crm,
  ...emailing,
  ...automations,
  ...notes,
  ...tasks,
  ...liveChat,
  ...calendar,
  ...scoring,
  ...openers,
  ...whatsappUnofficial,
  ...branding,
  ...agentAccess,
};
